// extracted by mini-css-extract-plugin
export default {"card-list":"VFJhDN","container":"JTOKgx"};